import Background from "./components/Background";
import Header from "./components/Header";
import Links from "./components/Links";

function App() {
  return (
    <div className="font-sans">
      <Background />
      <Header />
      <Links />
    </div>
  );
}

export default App;
